import { EducationInfo } from '../../../../../store/workspace/types';
import { EditIcon, TrashIcon } from '../../../../../assets/icons/common';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';
import InfoCard, { InfoRow } from '../../components/InfoCard';
import { useRecordDialogs } from '../../hooks/useRecordDialogs';
import { useProfileUpdate } from '../../hooks/useProfileUpdate';
import AddButton from '../../components/AddButton';
import EducationForm from './EducationForm';
import styles from './style.module.scss';

const byStartDate = (a: EducationInfo, b: EducationInfo) =>
    new Date(a.from).getTime() - new Date(b.from).getTime();

/** Lists the applicant's degrees, oldest first, and hosts the add / edit / delete dialogs. */
function Education() {
    const { profile, isSaving, saveProfile } = useProfileUpdate();
    const dialogs = useRecordDialogs<EducationInfo>();

    const records = profile?.educationInfo;
    const sorted = [...(records || [])].sort(byStartDate);

    const deleteRecord = async () => {
        if (!records || !dialogs.deleting) return;
        const saved = await saveProfile({
            educationInfo: records.filter(i => i.id !== dialogs.deleting?.id),
        });

        if (saved) dialogs.cancelDelete();
    };

    return (
        <div className={styles.wrapper}>
            {records?.length === 0 && <span>I don't have education experience.</span>}

            {sorted.map((item, index) => <InfoCard
                key={item.id}
                title={`Degree ${index + 1}`}
                actions={<>
                    <EditIcon onClick={() => dialogs.openEditForm(item)} />
                    <TrashIcon onClick={() => dialogs.askToDelete(item)} />
                </>}
            >
                <InfoRow wideLabel label='School  or university' value={item.universityName} />
                <InfoRow wideLabel label='Degree' value={item.degree} />
                <InfoRow wideLabel label='Field of study' value={item.field} />
                <InfoRow wideLabel label='Overal result (GPA)' value={item.GPA} />
                <InfoRow wideLabel label='Date' value={`${item.from} - ${item.to || 'Present'}`} />
            </InfoCard>)}

            <AddButton text='+ Add degree' onClick={dialogs.openAddForm} />

            {dialogs.isFormOpen && <EducationForm
                education={dialogs.editing}
                onClose={dialogs.closeForm}
            />}

            {dialogs.deleting && <ConfirmDeleteModal
                title='Delete degree'
                loading={isSaving}
                onConfirm={deleteRecord}
                onCancel={dialogs.cancelDelete}
                question={`Are you sure you want to delete "${dialogs.deleting.universityName}" ?`}
            />}
        </div>
    );
};

export default Education;
